// @flow
import {combineReducers} from 'redux';
import {signUpCheckOrderConsistencyReducer} from './CheckOrderConsistency';
import {signUpIndividualReducer} from './Individual';
import availablePhoneNumbersReducer from './AvailablePhoneNumbers';
import bonusReducer from './Bonus';
import deliveryAddressReducer from './DeliveryAddress';
import deliveryContactReducer from './DeliveryContact';
import deliveryMethodReducer from './DeliveryMethod';
import identificationsReducer from './Identifications';
import loginReducer from './Login';
import orderReducer from './Order';
import phoneNumberReducer from './PhoneNumber';
import regionReducer from './Region';
import simCardScanReducer from './SIMCardScan';
import simProductReducer from './Sim';
import {eSimProductReducer} from '../ESim';
import type {AddressType} from 'digicel-kaizen-library';
import type {AvailablePhoneNumbersStateType} from './AvailablePhoneNumbers/reducer';
import type {BonusStateType} from './Bonus';
import type {DeliveryContactStateType} from './DeliveryContact/reducer';
import type {DeliveryMethodStateType} from './DeliveryMethod/reducer';
import type {IdentificationsStateType} from './Identifications/reducer';
import type {LoginStateType} from './Login/reducer';
import type {PhoneNumberStateType} from './PhoneNumber/reducer';
import type {RegionStateType} from './Region';
import type {SignUpCheckOrderConsistencyStateType} from './CheckOrderConsistency';
import type {SignUpIndividualStateType} from './Individual';
import type {SignUpOrderStateType} from './Order/reducer';
import type {SIMCardScanStateType} from './SIMCardScan/reducer';
import type {SimProductType} from './Sim/reducer';
import type {EsimProductStateType} from '../Esim';

export type SignUpStateType = {|
  availablePhoneNumbers: AvailablePhoneNumbersStateType,
  bonus: BonusStateType,
  checkOrderConsistency: SignUpCheckOrderConsistencyStateType,
  deliveryAddress: AddressType,
  deliveryMethod?: DeliveryMethodStateType,
  deliveryContact?: DeliveryContactStateType,
  identifications: IdentificationsStateType,
  individual: SignUpIndividualStateType,
  login?: LoginStateType,
  order?: SignUpOrderStateType,
  phoneNumber: PhoneNumberStateType,
  region: RegionStateType,
  simCardScan: SIMCardScanStateType,
  simProduct: SimProductType,
  esimProduct: EsimProductStateType,
|};

export default combineReducers({
  availablePhoneNumbers: availablePhoneNumbersReducer,
  bonus: bonusReducer,
  checkOrderConsistency: signUpCheckOrderConsistencyReducer,
  deliveryAddress: deliveryAddressReducer,
  deliveryMethod: deliveryMethodReducer,
  deliveryContact: deliveryContactReducer,
  identifications: identificationsReducer,
  individual: signUpIndividualReducer,
  login: loginReducer,
  order: orderReducer,
  phoneNumber: phoneNumberReducer,
  region: regionReducer,
  simCardScan: simCardScanReducer,
  simProduct: simProductReducer,
  esimProduct: eSimProductReducer,
});
